/**
 * Domain type aliases over the generated OpenAPI schema.
 *
 * Import domain types from here, not from ./schema, so a regenerated spec with
 * renamed schemas only needs fixing in this one file. Add aliases as you need
 * them; keep the names the API uses.
 */
import type { components } from './schema'

type S = components['schemas']

export type Problem = S['Problem']
export type Me = S['Me']
export type Role = S['AdminRole']
export type Permission = S['Permission']

export type Application = S['Application']
export type ApplicationListItem = S['ApplicationListItem']
export type ApplicationDetail = S['ApplicationDetail']
export type ApplicationSettings = S['ApplicationSettings']
export type TestModeSettings = S['TestModeSettings']
export type CreateApplication = S['CreateApplication']
export type UpdateApplication = S['UpdateApplication']

export type StatsOverview = S['StatsOverview']
export type StatsRange = S['StatsRange']
export type StatusCounts = S['StatusCounts']
export type SeriesPoint = S['SeriesPoint']
export type QueueStats = S['QueueStats']
export type WorkersSummary = S['WorkersSummary']
export type SystemInfo = S['SystemInfo']

export type TemplateSummary = S['TemplateSummary']
export type EventTypeSummary = S['EventTypeSummary']
export type MessageSummary = S['MessageSummary']
export type MessageStatus = S['MessageStatus']

// Operations and configuration (AREA-OPS).
export type ApplicationStatus = S['ApplicationStatus']
export type ApplicationCounts = S['ApplicationCounts']
export type Sender = S['Sender']
export type CreateSender = S['CreateSender']
export type UpdateSender = S['UpdateSender']
export type Provider = S['Provider']
export type ApiKeyView = S['ApiKeyView']
export type CreateApiKey = S['CreateApiKey']
export type CreatedApiKey = S['CreatedApiKey']
export type KeyMode = S['KeyMode']
export type KeyStatus = S['KeyStatus']
export type WorkloadIdentity = S['WorkloadIdentity']
export type CreateWorkloadIdentity = S['CreateWorkloadIdentity']
export type WebhookEndpoint = S['WebhookEndpoint']
export type CreateWebhook = S['CreateWebhook']
export type UpdateWebhook = S['UpdateWebhook']
export type WebhookDelivery = S['WebhookDelivery']
export type WebhookDeliveryStatus = S['WebhookDeliveryStatus']
export type WebhookTestResponse = S['WebhookTestResponse']
export type Suppression = S['Suppression']
export type CreateSuppression = S['CreateSuppression']
export type SuppressionReason = S['SuppressionReason']
export type AuditEntry = S['AuditEntry']
export type ProposalDetail = S['ProposalDetail']
export type ProposalKind = S['ProposalKind']
export type ProposalSummary = S['ProposalSummary']
export type ProposalStatus = S['ProposalStatus']
export type ProposalTarget = S['ProposalTarget']
export type PartialUsage = S['PartialUsage']
export type PartialReference = S['PartialReference']
export type WorkerStatus = S['WorkerStatus']

/** Editor completion data (GET /admin/v1/event-types/{id}/context). */
export type ContextTree = S['ContextTree']

// Templates and partials (AREA-TEMPLATES).
export type Template = S['Template']
export type TemplateDetail = S['TemplateDetail']
export type TemplateFormat = S['TemplateFormat']
export type TemplateVersion = S['TemplateVersion']
export type TemplateVersionSummary = S['TemplateVersionSummary']
export type TemplateContent = S['TemplateContent']
export type CreateTemplate = S['CreateTemplate']
export type UpdateTemplate = S['UpdateTemplate']
export type SaveDraft = S['SaveDraft']
export type PublishTemplate = S['PublishTemplate']
export type RenderTemplateRequest = S['RenderTemplateRequest']
export type RenderTemplateResponse = S['RenderTemplateResponse']
export type RenderedContent = S['RenderedContent']
export type RenderWarning = S['RenderWarning']
export type RenderError = S['RenderError']
export type TestSendRequest = S['TestSendRequest']
export type TestSendResponse = S['TestSendResponse']
export type RuleRef = S['RuleRef']
/** A Handlebars partial. Named to avoid shadowing TypeScript's Partial<T>. */
export type TemplatePartial = S['Partial']
/** A partial with its open proposals (GET /partials/{id}). */
export type PartialDetail = S['PartialDetail']
/** A partial in a list, with its open proposal count. */
export type PartialSummary = S['PartialSummary']
export type CreatePartial = S['CreatePartial']
export type UpdatePartial = S['UpdatePartial']
export type EventSample = S['EventSample']

/** Every list endpoint returns this envelope (cursor pagination). */
// Events as facts: keys, history, send policies
export type EventKey = S['EventKey']
export type Unmatched = S['Unmatched']
export type RulePolicy = S['RulePolicy']
export type PolicySeenCheck = S['PolicySeenCheck']
export type PolicyWaitFor = S['PolicyWaitFor']
export type PolicyTiming = S['PolicyTiming']
export type PolicyTimingKind = S['PolicyTimingKind']
export type EntityEvent = S['EntityEvent']
export type PolicyItem = S['PolicyItem']
export type PolicyItemKind = S['PolicyItemKind']
export type Timeline = S['Timeline']
export type SimulateSequenceRequest = S['SimulateSequenceRequest']
export type SimulateSequenceResponse = S['SimulateSequenceResponse']
export type SequenceEvent = S['SequenceEvent']
export type LocaleContent = S['LocaleContent']

// Service Bus sources
export type ServiceBusSource = S['ServiceBusSourceView']
export type CreateServiceBusSource = S['CreateServiceBusSource']
export type UpdateServiceBusSource = S['UpdateServiceBusSource']
export type SourceMapping = S['SourceMapping']
export type SourceFormat = S['SourceFormat']
export type SourceState = S['SourceState']
export type ServiceBusAuth = S['ServiceBusAuth']
export type InboundMessage = S['InboundMessage']
export type InboundOutcome = S['InboundOutcome']
export type InboundVia = S['InboundVia']
export type SbMessageView = S['SbMessageView']
export type SbMessageList = S['MessageList']
export type SbPreview = S['Preview']
export type SbPreviewRequest = S['PreviewRequest']
export type ConnectionTest = S['ConnectionTest']
export type DeadLetterActionResponse = S['DeadLetterActionResponse']
export type DeadLetterResult = S['DeadLetterResult']
export type ReprocessResponse = S['ReprocessResponse']

export interface Page<T> {
  items: T[]
  next_cursor?: string | null
}

export const MESSAGE_STATUSES = [
  'held',
  'queued',
  'sending',
  'sent',
  'delivered',
  'bounced',
  'complained',
  'failed',
  'suppressed',
  'cancelled',
  'captured',
] as const satisfies readonly MessageStatus[]

/** Largest page size the API accepts. */
export const MAX_PAGE_SIZE = 200
